<div class="inline-block {{#if use-flex}}use-flex{{else}}use-inline{{/if}}" {{#if id}}id="{{id}}"{{/if}} data-region="{{cid}}-blocks"></div>